
import React, { useState,useEffect} from "react";

const documents = [
  {
    id: 1,
    category: "Guidelines",
    title: "Career Compass Facilitator's Guide",
    description: "Guide for counsellors delivering Career Compass training.",
    image:"./assets/careerc.png",
    link: "/PDF/DerejaLMSGuidingManuals/CareerCompassFacilitatorsguideCounsellorsLatest.pdf",
  },
  {
    id: 2,
    category: "Guidelines",
    title: "Dereja LMS Instructor Manual",
    description: "Instructor version of the Dereja LMS Manual.",
    image:"./assets/D1.png",
    link: "/PDF/DerejaLMSGuidingManuals/DerejaLMSManualInstructorsVersion.pdf",
  },
  {
    id: 3,
    category: "Guidelines",
    title: "Dereja LMS Learner Manual",
    description: "Learner version of the Dereja LMS Manual.",
    image:"./assets/DlS.jpg",
    link: "/PDF/DerejaLMSGuidingManuals/DerejaLMSManualVersionLearnerVersion.pdf",
  },
  {
    id: 4,
    category: "Trainer Manuals",
    title: "DLS Beginner Trainer Manual",
    description: "Manual for beginner-level trainers in Dereja Learning System.",
    image:"./assets/Dls.jpg",
    link: "/PDF/DerejaLMSGuidingManuals/DLSBeginnerTrainerManualSecondDraft.pdf",
  },
  {
    id: 5,
    category: "Trainer Manuals",
    title: "DLS Intermediate Trainer Manual",
    description: "Intermediate level training guide for trainers.",
    image:"./assets/Dls.jpg",
    link: "/PDF/DerejaLMSGuidingManuals/DLSIntermidateTrainersManualSecondDraft.pdf",
  },
  {
    id: 6,
    category: "Facilitator Guides",
    title: "Employability Skills Facilitator Guide",
    description: "Guide for delivering employability skill training.",
    image:"./assets/esjrlogo.jpg",
    link: "/PDF/DerejaLMSGuidingManuals/EmployabilityskilltrainingFacilitatorGuide.pdf",
  },
  {
    id: 7,
    category: "Training Manuals",
    title: "Employability Skills Training Manual",
    description: "Manual for employability skills sessions.",
    image:"./assets/esjrlogo.jpg",
    link: "/PDF/DerejaLMSGuidingManuals/Employabilityskilltrainingmanualfinal.pdf",
  },
  {
    id: 8,
    category: "Soft Skills",
    title: "Analytical Thinking Facilitator Guide",
    description: "Facilitator's guide for teaching analytical thinking.",
    image: "/assets/analytical.jpg",
    link: "/PDF/SoftSkillsModules/AnalyticalThinking/DAAPAnalyticalThinkingFacilitatorGuide.pdf",
  },
  {
    id: 9,
    category: "Soft Skills",
    title: "Analytical Thinking Manual",
    description: "Learner manual on analytical thinking skills.",
    image: "/assets/analytical.jpg",
    link: "/PDF/SoftSkillsModules/AnalyticalThinking/DAAPAnalyticalThinkingmanual.pdf",
  },
  {
    id: 10,
    category: "Career Guidance",
    title: "Career Guidance Program Guideline",
    description: "Guideline for Dereja Academy’s career guidance initiative.",
    image: "/assets/careerguide.jpg",
    link: "/PDF/SoftSkillsModules/Careerguidance/DerejaAcademyCareerGuidanceProgramGuideline.pdf",
  },
  {
    id: 11,
    category: "Communication",
    title: "Communication Skills Manual",
    description: "DAAP communication manual for learners.",
    image: "/assets/cs.jpg",
    link: "/PDF/SoftSkillsModules/Communication/DAAPCcommunicationManual.pdf",
  },
  {
    id: 12,
    category: "Communication",
    title: "New ODA Communication Guide",
    description: "Facilitator guide for new ODA communication.",
    image: "/assets/cs.jpg",
    link: "/PDF/SoftSkillsModules/Communication/NewODACommunicationfacilitatorguide.pdf",
  },
  {
    id: 13,
    category: "Financial Literacy",
    title: "Financial Management Facilitator Guide",
    description: "Teaching guide for personal financial management.",
    image: "/assets/financiallitracy.jpg",
    link: "/PDF/SoftSkillsModules/EffectiveFinancialMamagement/DAAPPersonalFinancialManagementFacilitatorGuide.pdf",
  },
  {
    id: 14,
    category: "Financial Literacy",
    title: "Financial Management Manual",
    description: "Learner manual on personal finance.",
    image: "/assets/financiallitracy.jpg",
    link: "/PDF/SoftSkillsModules/EffectiveFinancialMamagement/DAAPPersonalFinancialmanagementManual.pdf",
  },
  {
    id: 15,
    category: "Job Search Skills",
    title: "Effective Job Searching Guide",
    description: "Guide to help job seekers plan and execute job search strategies.",
    image: "/assets/jobsearch.png",
    link: "/PDF/SoftSkillsModules/EffectiveJobsearching/DAAPNewEffectiveJobsearchingfacilitatorguide.pdf",
  },
  {
    id: 16,
    category: "Planning Skills",
    title: "Effective Planning Facilitator Guide",
    description: "Facilitator guide for teaching planning and productivity.",
    image: "/assets/planning.png",
    link: "/PDF/SoftSkillsModules/EffectivePlanning/DAAPEffectivePlanningFacilitatorGuide.pdf",
  },
  {
    id: 17,
    category: "Planning Skills",
    title: "Effective Planning Manual",
    description: "Manual for learners on planning and execution.",
   image: "/assets/planning.png",
    link: "/PDF/SoftSkillsModules/EffectivePlanning/DAAPEffectivePlanningManual.pdf",
  },
  {
    id: 18,
    category: "Personal Branding",
    title: "Building Self Image - Part 1",
    description: "Manual to help youth build their personal brand.",
    image: "/assets/personalbrand.png",
    link: "/PDF/SoftSkillsModules/PersonalBranding/DAbuildingselfimagemanualPart1.pdf",
  },
  {
    id: 19,
    category: "Personal Branding",
    title: "Building Self Image - Part 2",
    description: "Continued module on personal branding and self-image.",
    image: "/assets/personalbrand.png",
    link: "/PDF/SoftSkillsModules/PersonalBranding/DABuildingselfimagemanualPart2.pdf",
  },
  {
    id: 20,
    category: "Self Discovery",
    title: "Self Discovery Facilitator Guide",
    description: "Facilitator's guide to help learners discover their strengths.",
    image: "/assets/selfdiscovery.jpg",
    link: "/PDF/SoftSkillsModules/Selfdiscovery/DAAPSelfDiscoveryfacilitatorguide.pdf",
  },
  {
    id: 21,
    category: "Self Discovery",
    title: "Self Discovery Manual",
    description: "Manual for exploring personal identity and goals.",
    image: "/assets/selfdiscovery.jpg",
    link: "/PDF/SoftSkillsModules/Selfdiscovery/DAAPSelfDiscoveryManual.pdf",
  },
  {
    id: 22,
    category: "Gender Inclusion",
    title: "Understanding Gender at Workplace",
    description: "Manual on gender equality and behavior in the workplace.",
    image: "/assets/genderinclusiveness.jpg",
    link: "/PDF/SoftSkillsModules/UnderstandingGenderWorkplace/DAAPUnderstandingGenderatWorkplace.pdf",
  },
  {
    id: 23,
    category: "Gender Inclusion",
    title: "Gender at Workplace Facilitator Guide",
    description: "Guide for teaching gender inclusiveness at work.",
    image: "assets/genderinclusiveness.jpg",
    link: "/PDF/SoftSkillsModules/UnderstandingGenderWorkplace/UnderstandingGenderattheWorkplacefacilitatorguide.pdf",
  },
];


export default function TrainingMaterial() {
  useEffect(() => {
        window.scrollTo(0, 0); 
      }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const itemsPerPage = 6;

  
  const filteredDocs = documents.filter((doc) =>
    doc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    doc.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredDocs.length / itemsPerPage);
  const startIndex = page * itemsPerPage;
  const paginatedDocs = filteredDocs.slice(startIndex, startIndex + itemsPerPage);

  const handleNext = () => {
    if (page < totalPages - 1) setPage(page + 1);
  };

  const handlePrev = () => {
    if (page > 0) setPage(page - 1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPage(0); 
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-orange mb-6 text-center">
        Knowledge Management Library
      </h1>

      <div className="max-w-2xl mx-auto mb-8">
        <input
          type="text"
          placeholder="Search documents..."
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
          onChange={handleSearch}
          value={searchTerm}
        />
        <p className="text-sm text-gray-600 mt-2">
          {filteredDocs.length > 0
            ? `Showing ${startIndex + 1}-${Math.min(
                startIndex + paginatedDocs.length,
                filteredDocs.length
              )} of ${filteredDocs.length} documents`
            : `No results found for "${searchTerm}"`}
        </p>
      </div>

      {filteredDocs.length > 0 ? (
        <>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
            {paginatedDocs.map((doc) => (
              <div
                key={doc.id}
                className="bg-white rounded-xl shadow hover:shadow-md p-4"
              >
                <img
                  src={doc.image}
                  alt={doc.title}
                  className="h-40 w-full object-cover rounded-md mb-4"
                />
                <h3 className="text-lg font-semibold text-gray-800">
                  {doc.title}
                </h3>
                <p className="text-sm text-gray-600">{doc.description}</p>
                <a
                  href={doc.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-block text-orange-600 hover:underline text-sm"
                >
                  View Document
                </a>
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-4">
            <button
              onClick={handlePrev}
              disabled={page === 0}
              className={`px-4 py-2 rounded-md font-semibold ${
                page === 0
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Previous
            </button>
            <button
              onClick={handleNext}
              disabled={page >= totalPages - 1}
              className={`px-4 py-2 rounded-md font-semibold ${
                page >= totalPages - 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Next
            </button>
          </div>
        </>
      ) : (
        <div className="text-center text-gray-500 text-lg mt-20">
          📄 No documents match your search.
        </div>
      )}
    </div>
  );
}
